"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference types="jquery"/>
var vue_1 = __importDefault(require("vue"));
var ConditionalDisplay_1 = __importDefault(require("../../Mixins/ConditionalDisplay"));
exports.default = vue_1.default.extend({
    props: ['label', 'route', 'sourceType', 'sourceTarget'],
    mixins: [ConditionalDisplay_1.default],
    data: function () {
        var model = this.$root.$data;
        var files = [];
        if (this.sourceTarget) {
            for (var _i = 0, _a = this.sourceTarget.split(','); _i < _a.length; _i++) {
                var target = _a[_i];
                var data = this.sourceType ? model.dataStore[this.sourceType.toLowerCase() + '_' + target] : "";
                if (data) {
                    var desData;
                    try {
                        desData = JSON.parse(data);
                    }
                    catch (e) {
                        desData = data;
                    }
                    files = files.concat(desData);
                }
            }
        }
        return {
            files: files,
            isvisible: files.length > 0
        };
    },
    methods: {
        /**
         * Construit une URL de téléchargement
         *
         * @param {Guid} publicId
         */
        getUrl: function (publicId) {
            var location = document.location;
            return location.protocol + "//" + location.host + "/Ged/Download/" + publicId;
        },
        /**
         * Construit une URL de visulisation
         *
         * @param {Guid} publicId
         */
        getPreviewUrl: function (publicId) {
            var location = document.location;
            return location.protocol + "//" + location.host + "/Ged/PreviewModal/" + publicId;
        },
        /**
         * Récupère l'extension du fichier
         */
        getFileExtension: function (fileName) {
            return $.getFileExtension(fileName);
        },
        /**
         * Récupère la class fa correspondante à l'extension du fichier
         */
        getFileExtensionCss: function (fileName) {
            return $.getFileExtensionCss(fileName);
        },
        getPublicIds: function () {
            return this.files.map(function (_) { return _.publicId; });
        },
    },
    mounted: function () {
        var _this = this;
        this.$watch('files', function () {
            return _this.isvisible = _this.files.length > 0;
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Output/FileListOutput.vue
// module id = 216
// module chunks = 0